export default __webpack_public_path__ + "static/media/cp_geo_ph.b70e266b.svg";